import {processApiRequest} from "../../Common/saga";
import * as ACTION from "./constants";
import settingApiService from '../../Setting/apiService';

export function* fetchSetting()  {
    yield processApiRequest(ACTION.FETCH_SETTING, () => {
        return settingApiService.getSetting();
    });
}